import React from 'react';
import { Box, Columns, styled, Text } from 'bumbag';

const RoundImage = styled.i`
  width: 50px;
  height: 50px;
  border-radius: 100px;
  background-color: #1173bc;
  color: #fff;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
type Props = {
  date?: string | null | undefined;
  hasCompleted: boolean;
  isProvider?: boolean;
  message?: string;
};

const MessageBox = ({ date, hasCompleted, isProvider, message }: Props) => {
  return (
    <Box>
      <Columns minBreakpoint="mobile">
        <Columns.Column paddingBottom="major-2">
          <h2>{isProvider ? 'Provider message' : 'Your message'}</h2>
        </Columns.Column>
        {date && (
          <Columns.Column spread={5} textAlign="right">
            <Text fontSize="150">{date}</Text>
          </Columns.Column>
        )}
      </Columns>
      {/* @ts-expect-error TS(2322): Type '"0"' is not assignable to type 'Flexible<Spa... Remove this comment to see the full error message */}
      <Columns marginTop="major-2" marginBottom="0">
        {!isProvider && <RoundImage className="fas fa-envelope fa-2x" />}
        {message && (
          <Columns.Column paddingTop="0px" paddingBottom="0px">
            {message}
          </Columns.Column>
        )}
      </Columns>
      {!hasCompleted && isProvider && <Box color="text100">Waiting for provider to reply...</Box>}
    </Box>
  );
};

MessageBox.defaultProps = {
  date: undefined,
  isProvider: false,
  message: undefined,
};
export default MessageBox;
